import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8666de04"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "main",
  style: {"margin":"10px"}
}
const _hoisted_2 = {
  class: "container",
  style: {"height":"55px"}
}
const _hoisted_3 = { class: "image" }
const _hoisted_4 = { class: "language-btn" }
const _hoisted_5 = { class: "button-font" }
const _hoisted_6 = {
  key: 1,
  class: "card bottom10px"
}
const _hoisted_7 = { class: "warning" }


import { ref, defineComponent, onMounted } from 'vue'
import { Tickets, ArrowLeft, DocumentCopy } from '@element-plus/icons-vue'
import store from '../store'
import { apiPostData, isNullValue, getI18n, setCookie, getCookie, setLanguage, isChinese, getDomain, getParameterByName } from '../utils'
import HelpCenter from '../components/HelpCenter.vue'
import PackageCard from '../components/PackageCard.vue'
import SimCard from '../components/SimCard.vue'
import { ElMessage } from 'element-plus'

const __default__ = defineComponent({
  name: 'QueryOrderView'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


// const refSimNo = ref('89852342022040149139')
// const refSimNo = ref('89852342022100442002')
const refSimNo = ref('')
const refHeadImage = ref('')

onMounted(async () => {
  refHeadImage.value = 'images/' + getDomain() + '-logo.png'

  const simNoInCookie = getCookie('simNo')
  if (simNoInCookie) {
    refSimNo.value = simNoInCookie
  }

  const simNo = getParameterByName('simNo')
  console.log('simNo=', simNo)
  if (simNo) {
    refSimNo.value = simNo
    query()
  }
})

function query () {
  queryUserPlan()
}

function queryUserPlan () {
  refSimNo.value = refSimNo.value.replace(/[^a-zA-Z0-9]/g, '')
  console.info('queryUserPlan', refSimNo.value)
  const data = { simNo: refSimNo.value }
  apiPostData('/h5/v1/sim/get-info', data)
    .then(data => {
      if (data !== null && data !== undefined) {
        store.state.simInfo = data
        if (data.code === 'ok') {
          store.state.isQueriedSim = false
          setCookie('simNo', refSimNo.value, 7)
        }
      }
    })
}
function goHome () {
  store.state.simInfo = { code: 'ok' }
  store.state.isQueriedSim = false
}

// 从剪贴板粘贴
const pasteFromClipboard = async () => {
  try {
    const text = await navigator.clipboard.readText()
    if (text) {
      refSimNo.value = text
    } else {
      ElMessage.warning(getI18n('剪贴板为空', 'Clipboard is empty.'))
    }
  } catch (err) {
    // ElMessage.error(getI18n('无法读取剪贴板，请手动粘贴', 'Unable to read clipboard, please paste manually.'))
    console.error(err)
  }
}


return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_image, { src: refHeadImage.value }, null, 8, ["src"])
      ]),
      (!_unref(isNullValue)(_unref(store).state.simInfo.data))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "image",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (goHome()))
          }, [
            _createVNode(_component_el_icon, { size: 35 }, {
              default: _withCtx(() => [
                _createVNode(_unref(ArrowLeft))
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (!_unref(isChinese)())
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              size: "small",
              plain: "",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(setLanguage)('zh')))
            }, {
              default: _withCtx(() => [
                _createTextVNode("中")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isChinese)())
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              type: "primary",
              size: "small",
              plain: "",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(setLanguage)('en')))
            }, {
              default: _withCtx(() => [
                _createTextVNode("EN")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_el_row, {
      align: "middle",
      class: "el-row-margin"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 18 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: refSimNo.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((refSimNo).value = $event)),
              placeholder: `${_unref(getI18n)('ICCID/SimNo/手机号', 'ICCID/SimNo/Phone Number')}`,
              clearable: "",
              class: "custom-select-height"
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_el_icon, {
                  size: 26,
                  onClick: pasteFromClipboard,
                  style: {"cursor":"pointer","margin-right":"8px","color":"#909399"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DocumentCopy))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 6,
          style: {"display":"flex","justify-content":"flex-end","align-items":"center"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (query()))
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(getI18n)('查询', 'Query')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_unref(store).state.simInfo.code == 'ok')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!_unref(isNullValue)(_unref(store).state.simInfo.data))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(SimCard, { simNo: refSimNo.value }, null, 8, ["simNo"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.simInfo.data.packageList, (plan) => {
                  return (_openBlock(), _createBlock(PackageCard, {
                    key: plan.orderId,
                    plan: plan
                  }, null, 8, ["plan"]))
                }), 128))
              ], 64))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_el_row, {
            class: "card-row",
            gutter: 20,
            align: "middle"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(store).state.simInfo.message), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(HelpCenter)
        ])),
    (_unref(isNullValue)(_unref(store).state.simInfo.data))
      ? (_openBlock(), _createBlock(HelpCenter, { key: 2 }))
      : _createCommentVNode("", true)
  ]))
}
}

})